import axios from 'axios';
import { DYNA_CROP_BASE_URL, REACT_APP_DYNA_CROP_API_KEY } from '../constants/dyna_crop';

const API_KEY = REACT_APP_DYNA_CROP_API_KEY;

const dynacropApi = axios.create({
    baseURL: DYNA_CROP_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'ApiKey': API_KEY
    }
});

// Interceptor to log errors or handle auth failures if needed
dynacropApi.interceptors.response.use(
    response => response,
    error => {
        console.error('Dynacrop API Error:', error);
        return Promise.reject(error);
    }
);

export const createPolygon = async (data) => {
    try {
        const response = await dynacropApi.post('/polygons', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getPolygons = async (params = {}) => {
    try {
        const response = await dynacropApi.get('/polygons', { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getPolygon = async (id) => {
    try {
        const response = await dynacropApi.get(`/polygons/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updatePolygon = async (id, data) => {
    try {
        const response = await dynacropApi.patch(`/polygons/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deletePolygon = async (id) => {
    try {
        const response = await dynacropApi.delete(`/polygons/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default dynacropApi;
